import React, { SVGProps } from 'react'
const SvgDepartmentsEmptyStateGrayscale = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={83}
    height={75}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <g
      clipPath="url(#DepartmentsEmptyState-Grayscale_svg__a)"
      filter="url(#DepartmentsEmptyState-Grayscale_svg__b)"
    >
      <path
        fill="#F6F7FB"
        fillRule="evenodd"
        d="M75.263 37.411c0 2.462-.27 4.853-.78 7.16-.176.81-.381 1.611-.615 2.392a33.436 33.436 0 0 1-2.04 5.17c-.24.492-.495.978-.764 1.449l-.007.007a31.672 31.672 0 0 1-2.726 4.136 33.17 33.17 0 0 1-2.57 2.961 34.113 34.113 0 0 1-5.388 4.474 34.652 34.652 0 0 1-3.61 2.096 33.463 33.463 0 0 1-8.674 2.947 33.669 33.669 0 0 1-6.457.619c-2.315 0-4.573-.232-6.754-.675A33.603 33.603 0 0 1 22.6 64.963C15.202 59.905 9.935 51.978 8.44 42.799V32.023a32.595 32.595 0 0 1 2.598-8.504c.425-.928.892-1.829 1.402-2.708A33.657 33.657 0 0 1 41.632 4c18.571 0 33.63 14.961 33.63 33.411Z"
        clipRule="evenodd"
      />
      <path
        fill={props.fill || '#697080'}
        d="M74.484 44.571c-.177.81-.382 1.611-.616 2.392a33.436 33.436 0 0 1-2.039 5.17c-.24.492-.496.977-.765 1.449l-.007.007a31.672 31.672 0 0 1-2.726 4.136 33.17 33.17 0 0 1-2.57 2.961 34.12 34.12 0 0 1-5.388 4.474 34.634 34.634 0 0 1-3.61 2.096 33.463 33.463 0 0 1-8.674 2.947v-31.35l24.986 5.015c.545.112 1.02.359 1.409.703Z"
      />
      <path
        fill={props.fill || '#B3B7BE'}
        d="M73.868 46.963a33.427 33.427 0 0 1-2.04 5.17c-.24.492-.495.977-.764 1.449l-.007.007a31.672 31.672 0 0 1-2.726 4.136 33.155 33.155 0 0 1-2.57 2.96 34.114 34.114 0 0 1-5.388 4.474 34.634 34.634 0 0 1-3.61 2.097 33.463 33.463 0 0 1-8.674 2.947V41.666l24.986 5.015c.283.057.545.148.793.282Z"
      />
      <path
        fill="#fff"
        d="M59.017 60.687h-4.87c-.823 0-1.49-.663-1.49-1.48 0-.818.667-1.48 1.49-1.48h4.87c.823 0 1.49.662 1.49 1.48 0 .817-.667 1.48-1.49 1.48Z"
        opacity={0.5}
      />
      <path
        fill="#fff"
        d="M60.373 65.16a34.652 34.652 0 0 1-3.61 2.096H54.15a1.49 1.49 0 0 1-1.494-1.484 1.49 1.49 0 0 1 1.494-1.485h4.864c.609 0 1.126.36 1.36.873ZM59.017 53.773h-4.87c-.823 0-1.49-.663-1.49-1.48 0-.818.667-1.481 1.49-1.481h4.87c.823 0 1.49.663 1.49 1.48 0 .818-.667 1.481-1.49 1.481Z"
        opacity={0.25}
      />
      <path
        fill="#fff"
        d="M68.331 57.725a33.137 33.137 0 0 1-2.57 2.96h-.283a1.483 1.483 0 0 1-1.494-1.476c0-.823.666-1.484 1.494-1.484h2.853Z"
        opacity={0.5}
      />
      <path
        fill="#fff"
        d="M71.829 52.133c-.24.492-.496.977-.765 1.449l-.007.007a1.44 1.44 0 0 1-.715.183h-4.864a1.483 1.483 0 0 1-1.494-1.477c0-.824.666-1.485 1.494-1.485h4.864c.772 0 1.402.577 1.487 1.323Z"
        opacity={0.25}
      />
      <path
        fill={props.fill || '#697080'}
        d="M48.09 29.716v40.487a33.669 33.669 0 0 1-6.458.619c-2.315 0-4.573-.232-6.754-.675A33.603 33.603 0 0 1 22.6 64.963C15.202 59.905 9.935 51.978 8.44 42.799V23.75c0-.957.403-1.892 1.175-2.469.7-.52 1.543-.696 2.344-.555l.48.084 33.207 5.993a2.957 2.957 0 0 1 2.442 2.912Z"
      />
      <path
        fill={props.fill || '#697080'}
        d="M48.09 32.53v37.673a33.669 33.669 0 0 1-6.458.619c-2.315 0-4.573-.232-6.754-.675A33.603 33.603 0 0 1 22.6 64.963C15.202 59.905 9.935 51.978 8.44 42.799V26.565c0-.957.403-1.892 1.175-2.47.432-.323.92-.513 1.423-.576.305-.042.616-.035.92.021l33.688 6.078a2.957 2.957 0 0 1 2.442 2.912Z"
      />
      <path
        fill="#F6F7FB"
        fillRule="evenodd"
        d="M34.878 64.745v5.402A33.603 33.603 0 0 1 22.6 64.963v-.218c0-1.35 1.338-2.448 2.988-2.448h6.308c1.643 0 2.98 1.097 2.98 2.448Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M25.334 52.478c0 .816-.666 1.477-1.487 1.477h-5.962a1.488 1.488 0 0 1-1.493-1.477c0-.816.672-1.485 1.494-1.485h5.961c.821 0 1.487.669 1.487 1.485ZM25.334 43.594c0 .816-.666 1.477-1.487 1.477h-5.962a1.488 1.488 0 0 1-1.493-1.477 1.49 1.49 0 0 1 1.494-1.484h5.961c.821 0 1.487.66 1.487 1.484Z"
      />
      <path
        fill="url(#DepartmentsEmptyState-Grayscale_svg__c)"
        d="M25.334 34.703c0 .823-.666 1.484-1.487 1.484h-5.962a1.49 1.49 0 0 1-1.493-1.484c0-.816.672-1.477 1.494-1.477h5.961c.821 0 1.487.661 1.487 1.477Z"
      />
      <path
        fill="url(#DepartmentsEmptyState-Grayscale_svg__d)"
        d="M40.443 52.478c0 .816-.666 1.477-1.494 1.477h-5.962a1.482 1.482 0 0 1-1.487-1.477c0-.816.666-1.485 1.487-1.485h5.962a1.49 1.49 0 0 1 1.494 1.485Z"
      />
      <path
        fill="url(#DepartmentsEmptyState-Grayscale_svg__e)"
        d="M40.443 43.594c0 .816-.666 1.477-1.494 1.477h-5.962a1.482 1.482 0 0 1-1.487-1.477c0-.823.666-1.484 1.487-1.484h5.962c.828 0 1.494.66 1.494 1.484Z"
      />
      <path
        fill="#fff"
        d="M40.443 34.703c0 .823-.666 1.484-1.494 1.484h-5.962a1.483 1.483 0 0 1-1.487-1.484c0-.816.666-1.477 1.487-1.477h5.962c.828 0 1.494.661 1.494 1.477Z"
      />
      <mask
        id="DepartmentsEmptyState-Grayscale_svg__f"
        width={68}
        height={67}
        x={8}
        y={4}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path
          fill="#F2F3F7"
          fillRule="evenodd"
          d="M75.263 37.411c0 2.462-.27 4.853-.78 7.16-.176.81-.381 1.611-.615 2.392a33.436 33.436 0 0 1-2.04 5.17c-.24.492-.495.978-.764 1.449l-.007.007a31.672 31.672 0 0 1-2.726 4.136 33.17 33.17 0 0 1-2.57 2.961 34.113 34.113 0 0 1-5.388 4.474 34.652 34.652 0 0 1-3.61 2.096 33.463 33.463 0 0 1-8.674 2.947 33.669 33.669 0 0 1-6.457.619c-2.315 0-4.573-.232-6.754-.675A33.603 33.603 0 0 1 22.6 64.963C15.202 59.905 9.935 51.978 8.44 42.799V32.023a32.595 32.595 0 0 1 2.598-8.504c.425-.928.892-1.829 1.402-2.708A33.657 33.657 0 0 1 41.632 4c18.571 0 33.63 14.961 33.63 33.411Z"
          clipRule="evenodd"
        />
      </mask>
      <g mask="url(#DepartmentsEmptyState-Grayscale_svg__f)">
        <g filter="url(#DepartmentsEmptyState-Grayscale_svg__g)">
          <path
            fill="#DADBE0"
            d="M52.027 69.415c-1.327-5.861.664-8.792 5.974-8.792 5.31 0 7.302 2.93 5.974 8.792"
          />
          <path
            fill="#EAEBF1"
            d="M58.001 63.26c2.112 0 3.824-1.77 3.824-3.956 0-2.185-1.712-3.957-3.824-3.957-2.111 0-3.823 1.772-3.823 3.957 0 2.185 1.712 3.956 3.823 3.956Z"
          />
        </g>
        <g
          fill={props.fill || '#B3B7BE'}
          filter="url(#DepartmentsEmptyState-Grayscale_svg__h)"
        >
          <path d="M27.955 70.822c-1.327-5.862.664-8.793 5.974-8.793 5.31 0 7.301 2.931 5.974 8.793" />
          <path d="M33.929 64.667c2.111 0 3.823-1.771 3.823-3.956s-1.712-3.957-3.823-3.957c-2.112 0-3.823 1.772-3.823 3.957 0 2.185 1.711 3.956 3.823 3.956Z" />
        </g>
        <g filter="url(#DepartmentsEmptyState-Grayscale_svg__i)">
          <path
            fill="#EAEBF1"
            d="M39.991 72.229c-1.327-5.862.664-8.793 5.974-8.793 5.31 0 7.301 2.931 5.974 8.793"
          />
          <path
            fill="#F6F7FB"
            d="M45.965 66.074c2.112 0 3.823-1.771 3.823-3.956 0-2.186-1.711-3.957-3.823-3.957-2.111 0-3.823 1.771-3.823 3.956 0 2.186 1.712 3.957 3.823 3.957Z"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="DepartmentsEmptyState-Grayscale_svg__b"
        width={80.822}
        height={80.822}
        x={1.441}
        y={-1}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1132_369"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1132_369"
          result="shape"
        />
      </filter>
      <filter
        id="DepartmentsEmptyState-Grayscale_svg__g"
        width={14.744}
        height={16.068}
        x={50.629}
        y={54.347}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1132_369"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1132_369"
          result="shape"
        />
      </filter>
      <filter
        id="DepartmentsEmptyState-Grayscale_svg__h"
        width={14.744}
        height={16.068}
        x={26.557}
        y={55.754}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1132_369"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1132_369"
          result="shape"
        />
      </filter>
      <filter
        id="DepartmentsEmptyState-Grayscale_svg__i"
        width={14.744}
        height={16.068}
        x={38.593}
        y={57.161}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1132_369"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1132_369"
          result="shape"
        />
      </filter>
      <linearGradient
        id="DepartmentsEmptyState-Grayscale_svg__c"
        x1={18.644}
        x2={23.415}
        y1={34.706}
        y2={34.706}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="DepartmentsEmptyState-Grayscale_svg__d"
        x1={33.752}
        x2={38.524}
        y1={52.474}
        y2={52.474}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="DepartmentsEmptyState-Grayscale_svg__e"
        x1={33.752}
        x2={38.524}
        y1={43.59}
        y2={43.59}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <clipPath id="DepartmentsEmptyState-Grayscale_svg__a">
        <path fill="#fff" d="M0 0h83v75H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgDepartmentsEmptyStateGrayscale
